import { type ColumnDef } from "@tanstack/react-table";
import React, { type FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Actions,
  DateTableCell,
  PaginationControl,
  ReactTableComponent,
  Typography,
  TypographyVariant,
  Status,
} from "../../../../components/ui-kit";
import {
  CompanyMembershipFullApiType,
  UserApiType,
} from "../../../../util/types";
// import { UserStatus } from "@shared_packages/toolkit/types";
import styled from "styled-components";
import { AppRoutes } from "../../../../constants/routes";

// const Switch = styled(SwitchButton)`
//   margin-left: 25px;
// `;

interface usersTableProps {
  data: UserApiType[];
  pagination: PaginationControl;
  onRowClick?: (user: UserApiType) => void;
  selectedUserId?: string;
  onDetachUser?: (user: UserApiType) => void;
}
export const CompaniesWrapper = styled.ul`
  padding: 0 0 0 12px;
`;

export const Li = styled.li``;

const PointWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const usersTable: FC<usersTableProps> = ({
  data,
  pagination,
  onRowClick,
  selectedUserId,
  onDetachUser,
}) => {
  const navigate = useNavigate();
  const defaultOnRowClick = useCallback(
    (row: UserApiType) => {
      navigate(`${AppRoutes.Private.Users.DETAILS + row._id}`);
    },
    [navigate]
  );

  const handleRowClick = onRowClick ?? defaultOnRowClick;

  const columns = React.useMemo<Array<ColumnDef<UserApiType, any>>>(
    () => [
      {
        header: "Name",
        meta: { mobileTitle: true },
        accessorKey: "firstName",
        enableSorting: false,
        cell: (info) => info.getValue(),
      },
      {
        header: "Last Name",
        accessorKey: "lastName",
        enableSorting: false,
        cell: (info) => info.getValue(),
      },
      {
        header: "Email",
        accessorKey: "email",
        enableSorting: false,
        cell: (info) => info.getValue(),
      },
      {
        header: "Companies and corresponding user status",
        accessorKey: "company",
        enableSorting: false,
        cell: ({ row: { original } }) => {
          return (
            <CompaniesWrapper>
              {original.companyMemberships
                ? original.companyMemberships?.map((c: any, i) => {
                    return (
                      <Li key={c?.company?._id ?? i}>
                        <PointWrapper>
                          <Typography variant={TypographyVariant.BODY3}>
                            {c?.company?.tradingName ?? c?.company?.name ?? "-"}
                          </Typography>
                          <div>
                            <Status status={c.status} />
                          </div>
                        </PointWrapper>
                      </Li>
                    );
                  })
                : "None"}
            </CompaniesWrapper>
          );
        },
      },
      {
        header: "Registered",
        accessorKey: "createdAt",
        enableSorting: false,
        cell: (info) => <DateTableCell date={info?.getValue()} />,
      },
      // {
      //   header: "Status",
      //   accessorKey: "status",
      //   enableSorting: false,
      //   cell: (info) => <Status status={info.getValue()} />,
      // },
      {
        header: "",
        accessorKey: "actions",
        cell: ({ row: { original } }) => {
          const actions = [
            {
              label: "View",
              onClick: () => {
                handleRowClick(original);
              },
            },
          ];

          if (onDetachUser) {
            actions.push({
              label: "Detach User",
              onClick: () => {
                onDetachUser(original);
              },
            });
          }

          return <Actions actions={actions} />;
        },
      },
    ],
    [handleRowClick, onDetachUser]
  );

  return (
    <>
      <ReactTableComponent
        columns={columns}
        data={data}
        onRowClick={handleRowClick}
        withPagination={pagination}
        withSorting
      />
    </>
  );
};

export default usersTable;
